import { cn } from "@/lib/utils";
import { Counter } from "@/components/ui/counter";
import { MAX_TEAM_REROLLS, MIN_TEAM_REROLLS } from "../constants";
import { useLanguage } from "../i18n";

export interface TeamRerollsProps {
  value: number;
  usedCount: number;
  onChange: (value: number) => void;
  className?: string;
}

export function TeamRerolls({ value, usedCount, onChange, className }: TeamRerollsProps) {
  const { t } = useLanguage();

  return (
    <div
      className={cn(
        "flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-4",
        "p-4 bg-bb-black border-2 border-bb-pitch-green",
        className
      )}
    >
      <label className="font-condensed text-lg uppercase text-bb-gold whitespace-nowrap">
        {t.teamRerolls}:
      </label>
      <Counter
        value={value}
        onChange={onChange}
        min={MIN_TEAM_REROLLS}
        max={MAX_TEAM_REROLLS}
        className="w-full sm:w-auto justify-center sm:justify-start"
      />
      <span className="text-sm text-bb-bone-white/70 sm:ml-auto">
        ({usedCount} {t.usedOf} {value})
      </span>
    </div>
  );
}
